// JoinMovementSection.js
import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import JoinForm from '../../components/JoinForm/joinform';
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/NewWFCOLogo2.svg'

import { homepgNavbarData } from '../../data/data';
import { homepgFooterData } from '../../data/data';

const JoinTheMovement = () => {
  return (
    <Fragment>
        <Navbar hclass={'wpo-site-header-s1'} topbarNone={'topbar-none'} Logo={Logo} data={homepgNavbarData}/>
        <PageTitle pageTitle={'Join the Movement'} pagesub={'Join the Movement'}/> 

        <div className="join-movement-section" style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem' }}>
            <div className="left-column" style={{ flex: '1', minWidth: '300px' }}>
                <h2>Join the Movement</h2>
                <p>
                    After signing up, we will reach out to schedule a chat to discuss the organization's goals.
                </p>
            </div>

            <div className="right-column" style={{ flex: '1', minWidth: '300px' }}>
                <JoinForm />
            </div>
        </div>

        <Footer logo={Logo} data={homepgFooterData}/>
    </Fragment>
  );
};

export default JoinTheMovement;
